import React from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { useDispatch } from "react-redux";
import { login } from "../../store/auth-actions";
import { baseUrl } from "../../axios/axios";
import { Message, useToaster } from "rsuite";

const clientId = "1010729304281-khqrkt8h05oc63ff4jq3a27ertdivkc4.apps.googleusercontent.com";

const GoogleAuth = () => {
  const dispatch = useDispatch();

  const toaster = useToaster();

  const successCallback = async (response: any) => {
    try {
      const decode = jwtDecode(response?.credential || "") as any;
      console.log(response);
      console.log(decode);

      const stringNeki = await axios.post(`${baseUrl}/authorization/google`, {
        username: decode?.email,
        password: decode?.sub,
        secondName: decode?.family_name,
        firstName: decode?.given_name,
        userPhoto: decode?.picture,
      });

      console.log(stringNeki);

      const loginData = await dispatch<any>(
        login({
          email: decode?.email,
          password: decode?.sub,
        })
      );
      console.log(loginData?.data);

      await axios.post(
        `${baseUrl}/apoteka_rs_server/authorization/google/update?access_token=${loginData?.data?.access_token}`,
        {
          username: decode?.email,
          password: stringNeki?.data,
        }
      );
    } catch (error) {
      console.log(error);
      toaster.push(<Message type="error">Došlo je do greške</Message>);
    }
  };

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleLogin
        locale="sr-Latn"
        theme="outline"
        onSuccess={(response) => {
          console.log("Login Success:", response);
          successCallback(response);
        }}
        onError={() => {
          console.log("Login Failed");
        }}
      />
    </GoogleOAuthProvider>
  );
};

export default GoogleAuth;
